<template>
<a-tooltip>
  <template slot="title">
    Add campaign
  </template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26.0596 12.5614C26.5483 12.5614 26.9618 12.7288 27.3001 13.0635C27.6759 13.3982 27.8639 13.8073 27.8639 14.2907C27.8639 14.7742 27.6947 15.2018 27.3564 15.5737C27.0181 15.9084 26.5859 16.0758 26.0596 16.0758H15.8544V26.1167C15.8544 26.6373 15.6852 27.065 15.3469 27.3997C15.0086 27.7344 14.5952 27.9017 14.1065 27.9017C13.6179 27.9017 13.2044 27.7344 12.8661 27.3997C12.5278 27.0278 12.3586 26.6001 12.3586 26.1167V16.0758H2.15337C1.66472 16.0758 1.23245 15.9084 0.856566 15.5737C0.518269 15.2018 0.349121 14.7742 0.349121 14.2907C0.349121 13.8073 0.518269 13.3982 0.856566 13.0635C1.23245 12.7288 1.66472 12.5614 2.15337 12.5614H12.3586V2.52052C12.3586 1.99988 12.5278 1.57221 12.8661 1.23752C13.2044 0.86563 13.6179 0.679688 14.1065 0.679688C14.5952 0.679688 15.0086 0.86563 15.3469 1.23752C15.6852 1.57221 15.8544 1.99988 15.8544 2.52052V12.5614H26.0596Z" fill="#B8CDD7"/>
</svg>
</a-tooltip>

</template>

<script>
export default {

}
</script>

<style scoped>
svg {
    cursor: pointer !important;
}
</style>